import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useScrollBottom } from '../../../../hooks/useScrollBottom';
import AppContext from '../../AppContext';
import { BotTyping } from './BotMessage/BotTyping';
import { Chats } from './Chats';
import { Modal, message } from 'antd';
import {
  replaceAllMessage,
  addMessage,
  removeAllMessages,
  toggleBotTyping
} from './messageSlice';
import { toggleNotification } from '../../widgetSlice';
import { scoutChatCenterServerUrl } from '../../../../autoConfig';
import { getInitialQuestion } from '../../../../autoConfig';

const MessagesDiv = styled.div`
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: "transparent"

}
/* Handle */
::-webkit-scrollbar-thumb {
  
  border-radius:20px;
  background-clip: "padding-box";
  background: ${(props) => props.widgetColor}; /* color of the scroll thumb */,
  border-radius: "20px"; /* roundness of the scroll thumb */,
  border: "none"; /* creates padding around scroll thumb */,
}
`;

export const Messages = ({ messageList }) => {
  const dispatch = useDispatch();
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const { widgetColor } = appContext;
  const { messages } = useSelector((state) => state.messageState);
  const bottomRef = useScrollBottom(messages);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showMessage, setShowMessage] = useState([]);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    // window.location.href = '/chat';
    navigate('/chat/');
  };
  const { id } = useParams();

  const addBotMessage = (text, msgId) => {
    // const path = window.location.pathname;
    // const pathSegments = path.split('/');
    // const pathId = pathSegments[pathSegments.length - 1];
    // msgId === pathId &&
    dispatch(
      addMessage({
        text: text,
        sender: 'BOT',
        chatId: msgId,
        type: 'text',
        ts: new Date(),
        humanAvatar:
          'https://cdn-assets-cloud.frontify.com/s3/frontify-cloud-files-us/eyJwYXRoIjoiZnJvbnRpZnlcL2FjY291bnRzXC9jZFwvMTk5ODU5XC9wcm9qZWN0c1wvMjY0OTE4XC9hc3NldHNcLzNkXC80NzI1MjU4XC8xYTBhOTZiOGE0NDU0MWFiMzU1MWMxNjUyYTNlYTk4Zi0xNjAwNjU0MzU2LnN2ZyJ9:frontify:gsQ9U0DuxzszjK_ObCuu-MR2AArYhXvQVFRWSvRC5Uc?width=2400'
      })
    );
  };

  // Human Handoff
  // ChatId === Enghouse; DialogueID === A365
  useEffect(() => {
    let ssEvents;
    if (sessionStorage.getItem(`${id}`)) {
      dispatch(replaceAllMessage(JSON.parse(sessionStorage.getItem(`${id}`))));
    } else {
      const name = JSON.parse(localStorage.getItem('username'))[0].value;
      ssEvents = new EventSource(
        `${scoutChatCenterServerUrl}/chat/joinChat/${id}/${name}`
      );
      ssEvents.addEventListener('new_message', (event) => {
        const message = JSON.parse(event.data).message;
        addBotMessage(message, event.lastEventId);
      });
      ssEvents.addEventListener('typing', async (event) => {
        if (JSON.parse(event.data).typing) {
          dispatch(toggleBotTyping(true));
        } else {
          dispatch(toggleBotTyping(false));
        }
      });
    }
    if (ssEvents) {
      ssEvents.onerror = function (error) {
        window.onbeforeunload = null;
        showModal();
        ssEvents.close();
        sessionStorage.removeItem(`${id}`);
      };
    }
    if (id) {
      window.onbeforeunload = function () {
        return 'Are you sure you want to leave?';
      };
    } else {
      window.onbeforeunload = null;
    }
    dispatch(toggleNotification(true));
  }, [id, dispatch]);

  const initMsg = {
    text: sessionStorage.getItem('consultantName')
      ? `Hello, this is ${sessionStorage.getItem(
          'consultantName'
        )}. ${getInitialQuestion(sessionStorage.getItem('consultantCountry'))}`
      : `Hello, ${getInitialQuestion(
          sessionStorage.getItem('consultantCountry')
        )}`,
    sender: 'USER',
    chatId: '',
    type: 'text',
    ts: new Date()
  };

  const pickupMessage = {
    text: sessionStorage.getItem('consultantName')
      ? `Hello, this is ${sessionStorage.getItem(
          'consultantName'
        )}. How can I help you today?`
      : `Hello, how can I help you today?`,
    sender: 'USER',
    chatId: '',
    type: 'text',
    ts: new Date()
  };

  useEffect(() => {
    const lastMessage = messages.slice(-1)[0];
    if (lastMessage) {
      const { chatId } = lastMessage;
      const key = chatId;
      let currentMessages = sessionStorage.getItem(key)
        ? JSON.parse(sessionStorage.getItem(key))
        : [];
      const isExistingMessage = currentMessages.some(
        (msg) => JSON.stringify(msg) === JSON.stringify(lastMessage)
      );
      const isInitMessage = currentMessages.some(
        (msg) => JSON.stringify(msg.text) === JSON.stringify(initMsg.text)
      );

      if (!isExistingMessage) {
        if (
          typeof lastMessage.text === 'string' &&
          lastMessage.text !== '' &&
          !lastMessage.text.startsWith('Hello,\n My name is')
        ) {
          currentMessages.push(lastMessage);
        }

        sessionStorage.setItem(key, JSON.stringify(currentMessages));
      }
      if (!isInitMessage) {
        JSON.parse(sessionStorage.getItem('chatList'))
          .find((item) => item.chatId === id)
          .consultantChatHistory.some(
            (msg) => JSON.stringify(msg.text) === JSON.stringify(initMsg.text)
          )
          ? currentMessages.push(pickupMessage)
          : currentMessages.push(initMsg);

        sessionStorage.setItem(
          key,
          JSON.stringify(
            Array.from(
              new Set(
                JSON.parse(sessionStorage.getItem('chatList'))
                  .find((item) => item.chatId === id)
                  .consultantChatHistory.concat(currentMessages)
                  .map((message) => message.text)
              )
            ).map((text) =>
              JSON.parse(sessionStorage.getItem('chatList'))
                .find((item) => item.chatId === id)
                .consultantChatHistory.concat(currentMessages)
                .find((message) => message.text === text)
            )
          )
        );
      }
    }
    const storedIdMessages = sessionStorage.getItem(id)
      ? JSON.parse(sessionStorage.getItem(id))
      : null;
    if (storedIdMessages) {
      setShowMessage(storedIdMessages);
    } else {
      setShowMessage(messages);
    }
  }, [messages, id, setShowMessage]);

  useEffect(() => {
    if (bottomRef.current) {
      setTimeout(() => {
        bottomRef.current.scrollIntoView({ behavior: 'smooth' });
      }, 100); // you can adjust the timeout value
    }
  }, [messages]);

  useEffect(() => {
    messageList && setShowMessage(messageList);
    messageList && dispatch(toggleNotification(false));
  }, [messageList]);

  return (
    <MessagesDiv
      className=" bottom-0 flex w-full flex-col space-y-1 self-start overflow-y-auto overflow-x-hidden bg-white p-2 pt-2"
      widgetColor={widgetColor}
    >
      <Chats messages={showMessage} />
      <BotTyping />

      {messageList ? null : (
        <Modal
          title="Chat Ended"
          open={isModalOpen}
          footer={null}
          onCancel={handleCancel}
        >
          <p>The chat connection has been ended.</p>
        </Modal>
      )}

      <div ref={bottomRef}></div>
    </MessagesDiv>
  );
};
